import React from 'react';
import Text from 'Components/ComponentLibrary/Atoms/Text';
import { Box, Stack } from '@facet-wealth/design';

export default function TransactionsDetailStat({ label, value, test }) {
  if (!value) return null;

  return <>
    <Box margin={200}>
      <Stack justifyContent={'space-between'} spacing={2} alignItems="flex-start">
        <Text align={'left'} variant={'h6'} color={'textSecondary'} value={label} test={`${test}-label`} />
        <Text align={'right'} variant={'h6'} color={'textPrimary'} value={value} test={`${test}-value`} />
      </Stack>
    </Box>
  </>;
}
